import { LabelLangString } from "component/LabelLang/label-lang";
import Linkable from "component/LinkableComponent/linkable-component";
import { API_BASE_URL } from "configs/AppConfig";
import { DateFormater } from "functions/dateTimeFormat";
import { Row, Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

const NewsSearchCard = ({ title, img, id = 1, date, tag, brief, translations }) => {

  const currentLocale = useSelector(({ theme }) => theme.locale);

  return (
    <div className="news-card browsetopic-item">
      <Row>
        <Col xs={12} md={5} lg={3} xl={2}>
          <img
            src={
              img
                ? `${API_BASE_URL}/${img}`
                : process.env.PUBLIC_URL + "/default_journal.png"
            }
            alt="news-img"
          />
        </Col>
        <Col xs={12} md={7} lg={9} xl={10} className="img-details">
          <div className="img-meta">
            <div style={{ fontSize: "16px" }}>
              <DateFormater value={date} />
            </div>
            {tag !== null && tag !== undefined && (
              <div className="img-separator">--</div>
            )}
            {tag !== null && tag !== undefined && (
              <div className="img-tag">{tag} </div>
            )}
          </div>
          <div className="img-title">
            {LabelLangString({
              id: "title",
              currentLocale: currentLocale,
              defaultValue: title,
              translations: translations
            })}
          </div>
          <div className="img-brief">
            {LabelLangString({
              id: "brief",
              currentLocale: currentLocale,
              defaultValue: brief,
              translations: translations
            })}
          </div>
          <div className="row-r mt-0">
            <Linkable
              link={`mediaLanding/news/${id}`}
              className="main-btn more-item"
            >
              <span>
                <FormattedMessage id="more" />
              </span>
              <i className="fas fa-ellipsis-h"> </i>
            </Linkable>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default NewsSearchCard;
